!
<template>
  <div class="metailItemwarp">
    <div
      class="achie_model"
      v-for="(itemk, index) in metailList"
      :key="index"
      @click="filedetails(itemk)"
    >
      <div class="achie_model_inner">
        <div class="achie_tops" v-if="['mp4'].includes(itemk.content.material.suffix)">
          <!-- controls -->
          <video
            v-if="itemk.content.material.coverVideoUrl"
            id="videomy"
            autoplay
            loop
            muted
            style="background-color: #fff"
            ref="myvideo"
            :src="formatUrl(itemk.content.material.coverVideoUrl)"
          >
            您的浏览器不支持 HTML5 video 标签。
          </video>
          <el-image
            v-else
            :src="formatUrl(itemk.content.material.coverUrl)"
            fit="cover"
          >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <div class="elcheck" v-show="itemk.mywidshow" @click.stop>
            <el-checkbox v-if="!itemk.disabled" @change="handChange(itemk)" :disabled="itemk.disabled" v-model="itemk.checkbol"></el-checkbox>
          </div>
        </div>
        <div class="achie_tops" v-else>
          <el-image :src="formatUrl(itemk.content.material.coverUrl)" fit="cover">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <div class="elcheck" v-show="itemk.mywidshow" @click.stop>
            <el-checkbox v-if="!itemk.disabled" @change="handChange(itemk)" :disabled="itemk.disabled" v-model="itemk.checkbol"></el-checkbox>
          </div>
        </div>


        <div class="achie_text">
          <div class="achiebotms">
            <p class="txtp1 txt-line1" :title="itemk.content.material.title">
              {{ itemk.content.material.title }}
            </p>
            <p class="txtp2 txtcolors">
              <i class="el-icon-view"></i> {{ itemk.content.material.clicks }}
            </p>
          </div>
          <div class="achie_sp">
            <p class="txtp1 txtcolors txt-line1">
              文件格式：{{ itemk.content.material.suffix }}
            </p>
            <p class="txtp2 txtcolors txt-line1">
              文件大小：{{ itemk.content.material.fileSize | calSize }}
            </p>
          </div>
          <div class="achie_sp">
            <p class="txtp3 txtcolors txt-line1">
              发布时间：{{ itemk.content.material.createTime.split(" ")[0] }}
            </p>
            <p class="creaname txtcolors txt-line1">
              发布人：{{ itemk.content.material.createName }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { calSize } from "@/utils";
import { postmeatil } from "@/api/home";
export default {
  name: "metailItem",
  data() {
    return {
      baseurl: process.env.VUE_APP_BASE_API,
      mouindex: 0,
      munshow: false,
    };
  },
  props: ["metailList"],
  mounted() {},
  filters: {
    calSize(fileSize) {
      return calSize(fileSize);
    },
  },
  methods: {
    handChange(item) {
      this.$emit('checkbox',item)
    },
    formatUrl(url) {
      var str = new RegExp("http");
      if (str.test(url)) {
        return url;
      } else {
        return url == null
          ? url
          : url.startsWith("/profile")
          ? this.baseurl + url
          : this.baseurl + "/profile/" + url;
      }
    },
    //详情
    filedetails(item) {
      // console.log(item.disabled)
      let rourl = this.$router.resolve({
        path: "/library-details",
        query: { id:item.id, title: "首页", tabindex: this.$store.state.user.tabindex },
      });
      this.metailadd(item.id);
      window.open(rourl.href);
    },
    //add素材库浏览量
    metailadd(resourceId) {
      let data = {
        resourceId: resourceId,
      };
      postmeatil(data).then((res) => {});
    },
    //鼠标移入
    vidconverPlay(e, item) {
      // e.target.play();
      this.mouindex = item.id;
      this.munshow = true;

    },
    //移出
    vidconverPause(e) {
      // e.target.pause();
      this.mouindex = 0;
      this.munshow = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.metailItemwarp {
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
  margin-left: -7px;
  margin-right: -7px;
}

.achie_model {
  padding: 0 7px;
  width: 25%;
  margin-bottom: 33px;

  .achie_model_inner {
    transition: all 0.4s;
    background-color: #fff;
    overflow: hidden;
    cursor: pointer;
    border: 1px solid #eeeeee;
    &:hover {
      box-shadow: 0px 0px 13px 0px rgba(53,87,73,0.17);
    }
  }
}

.achie_tops {
  height: 160px;
  position: relative;
  overflow: hidden;
}
.elcheck {
  position: absolute;
  right: 3px;
  bottom: 0;
}

.achie_model .achie_model_inner:hover .el-image {
  transform: scale(1.2);
}
.achie_tops > .el-image {
  width: 100%;
  height: 100%;
  transition: all 0.4s;
  font-size: 50px;
  line-height: 150px;
  color: #b3b3b3;
  text-align: center;
}
.achie_tops > #videomy {
  width: 100%;
  height: 100%;
  text-align: center;
}

/* 介绍 */
.achie_text {
  width: 100%;
  font-size: 14px;
  padding: 15px;
  background-color: #fff;
  .achie_sp {
    margin-bottom: 5px;
  }
  .txtcolors {
    font-size: 12px;
  }
  .achiebotms {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 10px;
    .txtp2 {
      width: 60px;
      text-align: right;
      line-height: 1;
      i {
        color: #1d4434;
      }
    }
    .txtp1 {
      flex: 1;
      line-height: 1;
      font-size: 16px;
    }
  }
  .achie_sp {
    display: flex;
    justify-content: space-between;
    color: #b3b3b3;
  }
}
</style>
